import type { Content, ListItem } from 'mdast'
import * as React from 'react'

import { List } from '../../list/List'

type MarkdownListItemProps = {
  node: ListItem
  handleNode: (node: Content) => React.ReactElement<unknown>
}

export const MarkdownListItem = ({
  node,
  handleNode
}: MarkdownListItemProps) => (
  <List.Item>{node.children?.map(handleNode)}</List.Item>
)
